"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.writeTar = void 0;
const file_1 = require("./file");
async function writeTar(collection, tarStream) {
    for (const item of collection) {
        if (item.file) {
            tarStream.beginFile(item.path, item.file.size);
            await tarStream.appendFile(new Uint8Array(await (0, file_1.fileArrayBuffer)(item.file)));
            await tarStream.endFile();
        }
        else {
            throw new Error('Invalid collection item');
        }
    }
}
exports.writeTar = writeTar;
